import React, { useContext } from 'react';
// import { AdminContext } from '../../../context/AdminContext';
import styles from './styles.module.scss';

const Divider = ({ className = '', children }) => {
  // const { themeColor } = useContext(AdminContext);
  return (
    <div
      className={`${styles.divider}${` `}${className} `}
    >
      {children}
    </div>
  );
};

export default Divider;
